/**
 * Copyright 2024-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { Table, theme } from "@nordcloud/gnui";
import { ResourcesSummary } from "~/views/plans/PlanCreate/components/PlanCreateWizard/PlanSummary/ResourcesSummary";
import { getActionDisplayName } from "~/views/plans/utils";
import { SelectedAction, SelectedPlanEntity } from "../types";
import { ResourceGroupSummary } from "./ResourceGroupsSummary";

export function PlanActionBatchSummary({
  batch,
}: {
  batch: SelectedPlanEntity;
  batchActions?: SelectedAction[];
}) {
  return (
    <>
      {batch.batchActions?.map((action: SelectedAction, idx: number) => {
        const { name, actionName, actionType } = action;
        const displayName = getActionDisplayName(
          name ?? "",
          actionName || "",
          actionType
        );

        return (
          <Table.tr key={`${action.listId}-${idx}`}>
            <Table.td>
              <ActionRow>{displayName}</ActionRow>
            </Table.td>
            <Table.td css={{ paddingBottom: "5px", paddingLeft: "0" }}>
              <ResourceGroupSummary action={action} />
            </Table.td>
            <Table.td
              css={{
                padding: `${theme.spacing.spacing03}`,
              }}
            >
              <ResourcesSummary action={action} />
            </Table.td>
          </Table.tr>
        );
      })}
    </>
  );
}

const ActionRow = styled.div`
  margin-bottom: ${theme.spacing.spacing02};
  word-break: break-word;
`;
